import React from 'react';
import { Poppins } from 'src/common';
import * as S from './MissingVariableBanner.styles';

interface MissingVariableBannerProps {
  /** Absent in read-only contexts (version snapshots) — the copy degrades to a plain statement. */
  onEdit?: () => void;
}

/** Details-page counterpart of the table's Missing-variables pill. */
export const MissingVariableBanner: React.FC<MissingVariableBannerProps> = ({ onEdit }) => (
  <S.Box data-cy="missing-variable-banner">
    <S.AlertIcon color="statusRed" cursorDefault />
    <Poppins px={14} color="prussianBlue">
      Missing required variable.
      {onEdit ? (
        <>
          {' '}
          <span className="edit-link" onClick={onEdit}>
            Edit this control
          </span>{' '}
          to add value.
        </>
      ) : null}
    </Poppins>
  </S.Box>
);
